var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iot",
    transform: "translate(-365 -181)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 32,
    height: 32,
    transform: "translate(365 181)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_internet_of_things_3215625",
    "data-name": "noun_internet of things_3215625",
    transform: "translate(362.225 179.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(5.775 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M32.99,41.414V40.021a6.029,6.029,0,0,0-.941.1A1.852,1.852,0,0,0,32.99,41.414Z",
    transform: "translate(-20.006 -22.822)",
    fill: "#f51e85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M30.321,21.738V13.116a2.129,2.129,0,1,0-1.989-3.447l-7.4-4.281a2.086,2.086,0,0,0,.142-.752,2.134,2.134,0,1,0-4.125.756l-7.4,4.277a2.128,2.128,0,1,0-1.989,3.447v8.622a2.129,2.129,0,1,0,2.026,3.4l7.256,4.194a1.961,1.961,0,0,0-.037.371,2.134,2.134,0,0,0,4.267,0,1.961,1.961,0,0,0-.037-.371l7.256-4.194a2.128,2.128,0,1,0,2.026-3.4Zm-11.033-15a2.15,2.15,0,0,0,1.306-.752l7.389,4.272a2.161,2.161,0,0,0,0,1.513l-4.556,2.645a2.586,2.586,0,0,0-1.054.151,4.783,4.783,0,0,0-3.089-3.039V6.74ZM9.9,10.26l7.389-4.272A2.183,2.183,0,0,0,18.6,6.74v4.63a4.837,4.837,0,0,0-.729-.064,4.72,4.72,0,0,0-4.249,2.631L9.9,11.773A2.271,2.271,0,0,0,9.9,10.26ZM9.547,22.48a2.353,2.353,0,0,0-1.3-.752v-8.6a2.174,2.174,0,0,0,1.3-.756l3.809,2.214a4.664,4.664,0,0,0-.225,1.224,3.645,3.645,0,0,0-2.8,3.566,3.608,3.608,0,0,0,.752,2.214ZM18.6,27.6a2.155,2.155,0,0,0-1.526,1.077L9.919,24.538A2.122,2.122,0,0,0,9.9,23.076l1.673-.972A3.633,3.633,0,0,0,14,23.035h4.6Zm.34-6.115c-.015,0-.029,0-.043,0a3.364,3.364,0,0,1,.017-6.728l.026,0,.03,0a3.364,3.364,0,0,1,.017,6.728C18.971,21.477,18.956,21.481,18.94,21.481Zm9.025,3.053L20.81,28.673A2.19,2.19,0,0,0,19.288,27.6V23.035h5.326a2.917,2.917,0,0,0,1.976-.77l1.4.811A2.115,2.115,0,0,0,27.965,24.534Zm1.668-2.805a2.172,2.172,0,0,0-1.3.752l-1.293-.752a2.917,2.917,0,0,0,.5-1.627,2.949,2.949,0,0,0-1.774-2.691,2.536,2.536,0,0,0-1.4-2.746l3.956-2.3a2.234,2.234,0,0,0,1.3.756v8.6Z",
    transform: "translate(-5.775 -2.5)",
    fill: "#f51e85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M31.677,38.107A6.35,6.35,0,0,1,32.711,38V36.952H31.534A5.9,5.9,0,0,0,31.677,38.107Z",
    transform: "translate(-19.727 -21.16)",
    fill: "#f51e85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M29.242,36.952h-1.28a2.956,2.956,0,0,0,.556,1.569,4.024,4.024,0,0,1,.874-.335A6.221,6.221,0,0,1,29.242,36.952Z",
    transform: "translate(-17.792 -21.16)",
    fill: "#f51e85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M29.392,33.086a4.058,4.058,0,0,1-.874-.333,2.95,2.95,0,0,0-.556,1.567h1.28A6.227,6.227,0,0,1,29.392,33.086Z",
    transform: "translate(-17.792 -18.886)",
    fill: "#f51e85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M31.534,34.807h1.177V33.762a6.378,6.378,0,0,1-1.034-.109A5.9,5.9,0,0,0,31.534,34.807Z",
    transform: "translate(-19.727 -19.373)",
    fill: "#f51e85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M30.966,30.313a2.933,2.933,0,0,0-1.3.836,3.855,3.855,0,0,0,.744.266A3.224,3.224,0,0,1,30.966,30.313Z",
    transform: "translate(-18.714 -17.564)",
    fill: "#f51e85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M29.664,40.676a2.952,2.952,0,0,0,1.3.833,3.224,3.224,0,0,1-.557-1.1A3.822,3.822,0,0,0,29.664,40.676Z",
    transform: "translate(-18.714 -23.033)",
    fill: "#f51e85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M34.883,30.061v1.394a6.059,6.059,0,0,0,.944-.1A1.846,1.846,0,0,0,34.883,30.061Z",
    transform: "translate(-21.541 -17.428)",
    fill: "#f51e85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M36.064,36.952H34.883V38a6.357,6.357,0,0,1,1.037.11A5.9,5.9,0,0,0,36.064,36.952Z",
    transform: "translate(-21.541 -21.16)",
    fill: "#f51e85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M35.92,33.651a6.38,6.38,0,0,1-1.037.11v1.045h1.181A5.906,5.906,0,0,0,35.92,33.651Z",
    transform: "translate(-21.541 -19.372)",
    fill: "#f51e85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M34.883,40.021v1.395a1.846,1.846,0,0,0,.945-1.3A6.036,6.036,0,0,0,34.883,40.021Z",
    transform: "translate(-21.541 -22.822)",
    fill: "#f51e85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M36.49,41.51a2.946,2.946,0,0,0,1.3-.833,3.839,3.839,0,0,0-.745-.267A3.224,3.224,0,0,1,36.49,41.51Z",
    transform: "translate(-22.411 -23.034)",
    fill: "#f51e85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M32.049,31.361a6.054,6.054,0,0,0,.941.1V30.064A1.852,1.852,0,0,0,32.049,31.361Z",
    transform: "translate(-20.006 -17.429)",
    fill: "#f51e85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M37.79,31.149a2.933,2.933,0,0,0-1.3-.835,3.223,3.223,0,0,1,.557,1.1A3.88,3.88,0,0,0,37.79,31.149Z",
    transform: "translate(-22.41 -17.565)",
    fill: "#f51e85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M38.061,34.32h1.28a2.95,2.95,0,0,0-.556-1.567,4.091,4.091,0,0,1-.874.332A6.22,6.22,0,0,1,38.061,34.32Z",
    transform: "translate(-23.18 -18.886)",
    fill: "#f51e85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M37.91,38.188a4.057,4.057,0,0,1,.875.334,2.959,2.959,0,0,0,.556-1.57h-1.28A6.23,6.23,0,0,1,37.91,38.188Z",
    transform: "translate(-23.18 -21.16)",
    fill: "#f51e85"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIot);
export default __webpack_public_path__ + "static/media/iot.aefe590169aef02b0e933afb3a58a5c1.svg";
export { ForwardRef as ReactComponent };